import app from './modules/app';
import auth from './modules/auth';
import toDoSuspenses from './modules/toDoSuspenses';
import account from './modules/account';
import phoneBookData from './modules/phoneBookData';
import contact from './modules/contact';
import farm from './modules/farm';
import assetReview from './modules/assetReview';
import owner from './modules/owner';
import tenant from './modules/tenant';
import fsaOffices from './modules/fsaOffices';
import mvSalesComparisons from './modules/mvSalesComparisons';
import managers from './modules/managers';
import cropInsurancePrices from './modules/cropInsurancePrices';
import cropProductionSalesReport from './modules/cropProductionSalesReport';
import farmInspection from './modules/farmInspection';
import farmLeaseCashCrp from './modules/farmLeaseCashCrp';

export default {
  app,
  auth,
  toDoSuspenses,
  account,
  phoneBookData,
  contact,
  farm,
  assetReview,
  owner,
  tenant,
  fsaOffices,
  mvSalesComparisons,
  managers,
  cropInsurancePrices,
  cropProductionSalesReport,
  farmInspection,
  farmLeaseCashCrp
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js